// components/Checkout/OrderConfirmation.tsx
import { FaCheckCircle, FaInfoCircle } from 'react-icons/fa';

interface OrderConfirmationProps {
  paymentMethod: string;
  bankDetails: any;
  orderId?: string;
  onContinue: () => void;
}

export function OrderConfirmation({
  paymentMethod,
  bankDetails,
  orderId,
  onContinue,
}: OrderConfirmationProps) {
  const orderIdDisplay = orderId || '#' + Math.random().toString(36).substring(2, 10).toUpperCase();

  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={onContinue}>
      <div className="bg-white rounded-3xl max-w-md w-full p-8 text-center" onClick={(e) => e.stopPropagation()}>
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <FaCheckCircle className="text-green-600 text-4xl" />
        </div>
        <h2 className="font-primary text-2xl font-bold text-gray-800 mb-2">
          {paymentMethod === 'cod' ? 'Order Placed! 🎉' : 'Order Confirmed!'}
        </h2>
        <p className="font-secondary text-gray-500 mb-4">
          {paymentMethod === 'cod'
            ? 'Your order has been placed. Please keep the exact amount ready for delivery.'
            : paymentMethod === 'bank'
            ? 'Please complete the bank transfer to confirm your order.'
            : 'Thank you for your purchase. Your order has been confirmed.'}
        </p>
        <div className="bg-gray-50 rounded-xl p-4 mb-6">
          <p className="font-secondary text-sm text-gray-600">
            Order ID: <span className="font-mono font-bold text-gray-800">{orderIdDisplay}</span>
          </p>
          {paymentMethod === 'cod' && (
            <p className="font-secondary text-xs text-amber-600 mt-2">📦 Payment will be collected upon delivery</p>
          )}
        </div>
        {paymentMethod === 'bank' && (
          <div className="bg-blue-50 rounded-xl p-4 mb-4 text-left">
            <h4 className="font-primary font-semibold text-gray-800 mb-2">Bank Transfer Details</h4>
            <div className="space-y-1 text-sm text-gray-600">
              <p><span className="font-medium">Bank:</span> {bankDetails.bank}</p>
              <p><span className="font-medium">Account Name:</span> {bankDetails.accountName}</p>
              <p><span className="font-medium">Account Number:</span> {bankDetails.accountNumber}</p>
              <p><span className="font-medium">Reference:</span> {bankDetails.reference}</p>
            </div>
          </div>
        )}
        <button
          onClick={onContinue}
          className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-primary font-semibold py-3 rounded-xl transition-all duration-200"
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
}